import { getUrlParamByName, currentUrlToParams } from '@/utils/common.js'
import { decodeChannelInfo, getActivityChannel } from '@/api/api.js'
import { wbAlert } from '@/utils/tips.js'
import autoLoading from '@/utils/auto-loading.js'
import appConfig from '@/config/index.js'

// 登陆页逻辑
// 默认、渠道登录 => 登录注册后跳转下载页
// 百度推广 => 登录注册后判断开户状态，根据开户状态跳转
// 微信服务号 => 登录注册后（绑定账号），跳转绑定状态页
// 活动页 => 有活动邀请人，登陆后绑定邀请人跳转下载页；无邀请人，登陆后根据开户状态跳转

class LoginHelper {
  static inviterId = undefined // 邀请人盈宝id
  static channelId = undefined // 渠道id
  static utmSource = undefined // 来源类型
  static utmMedium = undefined // 来源媒介

  static wxOpenId = undefined // 微信用户openId
  static wxNickname = undefined // 微信用户昵称
  static get isWechatAuth() {
    return this.wxOpenId && this.wxNickname
  }

  static bdPromote = false // 是否是百度推广入口进来的

  static appLink = undefined // 调整下载页唤起app路由
  static activityId = undefined // 活动id
  static activityUserId = undefined // 活动邀请人

  static initLoginParams(vue) {
    this.checkAppLink()
    this.checkWeChatAuth()
    this.checkBaiduPromote()
    this.checkChannelInfo(vue)
    this.checkActivityInfo()
  }

  static checkAppLink() {
    const appLink = getUrlParamByName('appLink')
    this.appLink = appLink
  }

  // 检查是否有微信权限
  static checkWeChatAuth() {
    const openId = getUrlParamByName('openId')
    const nickname = getUrlParamByName('nickname')
    this.wxOpenId = openId
    this.wxNickname = nickname
  }

  // 检查是否是百度推广页进入
  static checkBaiduPromote() {
    const bdPromote = getUrlParamByName('bdPromote')
    this.bdPromote = [true, 'true'].includes(bdPromote)
  }

  // 检查渠道信息
  static async checkChannelInfo(vue) {
    try {
      const channelCode = currentUrlToParams(window.location.href, 'key')
      if (!channelCode) {
        return
      }
      const { code, data } = await decodeChannelInfo(channelCode)
      if (code === 0) {
        const { inviterId, channelId, utmSource, utmMedium, status } = data
        // 渠道已失效
        if (status + '' === '0') {
          this.inviterId = undefined
          this.channelId = undefined
          this.utmSource = undefined
          this.utmMedium = undefined
          wbAlert(vue.$t('login.registerChannelValid'), function(closeFunc) {
            window.location.replace(`./index.html`)
          })
        } else {
          this.inviterId = inviterId
          this.channelId = channelId
          this.utmSource = utmSource
          this.utmMedium = utmMedium
        }
      }
    } catch (error) {
      this.inviterId = undefined
      this.channelId = undefined
      this.utmSource = undefined
      this.utmMedium = undefined
    }
  }

  // 检查是否是从活动页面进入
  static checkActivityInfo() {
    const activityId = getUrlParamByName('activityId')
    const activityUserId = getUrlParamByName('activityUserId')
    if (activityUserId) {
      this.activityUserId = activityUserId
    }
    if (activityId) {
      this.activityId = activityId
      const fromUrl = document.referrer
      if (fromUrl.indexOf('area-list') === -1) {
        localStorage.setItem('fromActivityUrl', fromUrl)
      }
      // 获取活动关联渠道
      this.checkActivityChannel()
    }
  }

  // 检查活动是否关联渠道
  static async checkActivityChannel() {
    const { code, data } = await autoLoading(getActivityChannel(this.activityId))
    if (code === 0 && data) {
      // console.log(data)
      this.channelId = data
    }
  }

  // 登陆成功后的操作
  static loginSuccessHandle(data) {
    if (!this.bdPromote) {
      if (this.activityId) {
        if (this.activityUserId) {
          this.inviteActivityLoginSuccessHandle(data)
        } else {
          this.activityLoginSuccessHandle(data)
        }
      } else {
        // 默认、渠道登录跳转下载页
        window.location.href = `./download.html`
      }
    } else {
      // 百度推广页，判断开户状态
      const { user, token } = data
      if (user.accountOpened) {
        window.location.href = `./download.html`
      } else {
        window.localStorage.setItem(appConfig.tokenKey, token)
        Storage.set(appConfig.userInfoKey, user)
        window.location.href = `./open-account.html`
      }
    }
  }

  // 生成邀请绑定活动提交参数
  static buildInviteActivitySubmitParam(loginParams) {
    return {
      activityId: this.activityId,
      userId: this.activityUserId,
      userVerifyCodeLoginDTO: loginParams
    }
  }

  // 活动登录成功后的操作
  static async activityLoginSuccessHandle(data) {
    const {
      user: { accountOpened },
      token
    } = data
    window.localStorage.setItem(appConfig.tokenKey, token)
    if (this.appLink === 'activity_center') {
      window.location.href = `./download.html?appLink=${this.appLink}&id=${this.activityId}`
      return
    }
    if (accountOpened) {
      const fromActivityUrl = localStorage.getItem('fromActivityUrl')
      localStorage.removeItem('fromActivityUrl')
      localStorage.setItem('needActivityHandle', true)
      window.location.href = fromActivityUrl
    } else {
      window.location.href = `./download.html?from=activity`
    }
  }

  // 邀请绑定活动登录成功
  static inviteActivityLoginSuccessHandle(data) {
    window.location.href = `./download.html`
  }

  // 微信绑定结果处理
  static wxBindResHandle(code, msg) {
    setTimeout(() => {
      if (code === 0) {
        window.location.replace(`./wx-bind-res.html?state=1`)
      } else if ([7300, 7301].includes(code)) {
        // 7300: 微信已经绑定过盈宝号
        // 7301: 盈宝号已经绑定其它微信
        window.location.replace(`./wx-bind-res.html?state=3`)
      } else {
        window.location.replace(`./wx-bind-res.html?state=2`)
      }
    })
  }
}

export default LoginHelper
